import { getFunctions, httpsCallable } from "firebase/functions";
import app from "./firebaseApp";

const functions = getFunctions(app);

// Fonctions pour la gestion des droits admin
export const manageAdminRights = httpsCallable(functions, "manageAdminRights");
export const listAdminUsers = httpsCallable(functions, "listAdminUsers");

export default functions;
